import StoryCard from './StoryCard'
export default StoryCard
